'use client';

import { Box, Button, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import Link from 'next/link';
import { useEffect, useMemo } from 'react';
import { usePlans } from '@/api/hooks/usePlans';
import PlanInfo from '@/components/plan-info/PlanInfo';
import Container from '@/components/layout/Container';
import Section from '@/components/Section';
import { PlanStatusDTO } from '@/types/models';
import { sendGoogleGTMEvent } from '@/utils/googleGTM';
const texts = {
  title: 'فرصت‌های سرمایه‌گذاری زیما',
  btnTitle: 'طرح‌های سرمایه‌گذاری پیشین'
};
const PlansList = (): JSX.Element => {
  const {
    data
  } = usePlans({
    limit: 6
  });
  const plans = useMemo(() => {
    const items = data.filter(item => item.status === PlanStatusDTO.inProgress);
    if (items.length >= 3) return items;
    return [...items, ...data.filter(f => f.status !== PlanStatusDTO.inProgress && !items.some(item => item.id === f.id)).slice(0, 3 - items.length)];
  }, [data]);
  useEffect(() => {
    if (plans.length === 0) return;
    sendGoogleGTMEvent({
      event: 'view_home_item_list',
      items: plans.map((item, index) => ({
        item_id: item.id,
        item_name: item.title,
        thepercent: Math.floor(+item.providedFund / +item.maxInvestment * 100),
        index
      }))
    });
  }, [plans]);
  return <Box sx={{
    background: 'linear-gradient(180deg, rgb(229 242 255) 0%, rgb(255 255 255) 100%)'
  }} data-sentry-element="Box" data-sentry-component="PlansList" data-sentry-source-file="PlansList.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="PlansList.tsx">
        <Section id='plans' data-sentry-element="Section" data-sentry-source-file="PlansList.tsx">
          <Typography typography={{
          xs: 'titleStrong__Wallfund',
          md: 'displayStrong__Wallfund'
        }} color='text.text' textAlign='center' component='h2' data-sentry-element="Typography" data-sentry-source-file="PlansList.tsx">
            {texts.title}
          </Typography>

          <Grid container rowGap='var(--spacing_xxxl)' columnSpacing={2} data-sentry-element="Grid" data-sentry-source-file="PlansList.tsx">
            {(plans || []).map((item, idx) => {
            return <Grid xs={12} sm={6} md={6} lg={4} key={'plan_' + idx}>
                  <PlanInfo data={item} hasDetail />
                </Grid>;
          })}
          </Grid>

          <Box textAlign='center' data-sentry-element="Box" data-sentry-source-file="PlansList.tsx">
            <Button variant='outlined' sx={{
            typography: 'bodyLargeMedium__Wallfund'
          }} href='/crowdfunding-plan' size='large' LinkComponent={Link} data-sentry-element="Button" data-sentry-source-file="PlansList.tsx">
              {texts.btnTitle}
            </Button>
          </Box>
        </Section>
      </Container>
    </Box>;
};
export default PlansList;